import { LocationDetailsHeapAttributes } from './locationDetails/locationHeapAttributes'

export const DefaultHeapAttributes = {
  button: 'default-button',
  dropdownButton: 'default-dropdown-button',
  dropdownButtonOption: 'default-dropdown-button-option',
} as const

const _ALL_HEAP_ATTRIBUTES = [
  ...Object.values(DefaultHeapAttributes),
  ...Object.values(LocationDetailsHeapAttributes),
] as const

export type HeapAttributesType = (typeof _ALL_HEAP_ATTRIBUTES)[number]
